import { render, staticRenderFns } from "./multiTextProperty.vue?vue&type=template&id=521d8c42"
import script from "./multiTextProperty.vue?vue&type=script&lang=js"
export * from "./multiTextProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports